import { Box, Tooltip, Typography } from '@rossum/ui/material';
import clsx from 'clsx';
import ArrowDownDropCircleOutlineIcon from 'mdi-react/ArrowDownDropCircleOutlineIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import { useIntl } from 'react-intl';
import { OriginalAnyDatapointSchema } from '../../../../../types/schema';
import { isFieldRequired } from '../helpers';
import scrollingSubject from '../lib/scrollingSubject';
import styles from '../styles.module.sass';
import { sharedStyles } from './sharedStyles';

type Props = {
  inFooter?: boolean;
  isOpen: boolean;
  optionsCount: number;
  type: string;
  toggleCurrent: () => void;
} & Pick<OriginalAnyDatapointSchema, 'label' | 'constraints' | 'hidden' | 'id'>;

const Enum = ({
  constraints,
  hidden,
  id,
  inFooter,
  isOpen,
  label,
  optionsCount,
  type,
  toggleCurrent,
}: Props) => {
  const intl = useIntl();
  const handleClick = () => {
    toggleCurrent();
    scrollingSubject.next(id);
  };
  return (
    <Box
      onClick={handleClick}
      sx={
        inFooter
          ? {}
          : {
              ...sharedStyles,
              ...(isOpen
                ? {
                    borderLeft: t => `5px solid ${t.palette.primary.main}`,
                    backgroundColor: t => t.palette.action.selected,
                    '&:hover': {
                      backgroundColor: t => t.palette.action.selected,
                    },
                  }
                : {}),
            }
      }
    >
      {!inFooter && (
        <div className={styles.TitleEncapsulor}>
          <Typography>
            {label}
            {isFieldRequired(constraints, type) && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'containers.settings.queues.schema.sidebar.required',
                })}
              >
                <span className={styles.Requirer}>&nbsp;*</span>
              </Tooltip>
            )}
          </Typography>
          {hidden && <EyeOffIcon className={styles.HiddenIcon} />}
        </div>
      )}
      <Box
        sx={{ backgroundColor: t => t.palette.background.default }}
        className={clsx(
          styles.Multivalue,
          isOpen &&
            (inFooter ? styles.ActiveFooterMultivalue : styles.ActiveMultivalue)
        )}
      >
        <Typography component="span">{optionsCount}</Typography>
        <ArrowDownDropCircleOutlineIcon />
      </Box>
    </Box>
  );
};

export default Enum;
